module.exports = __webpack_public_path__ + "fonts/SFProText-Medium.92ad8f72.woff";